import Cookies from 'js-cookie'
import { Platform } from 'react-native'
import storage from '../storage'

const AUTH_TOKEN_KEY = 'auth_token'
const COOKIE_NAME = '_gd_m_t'

export function getAuthToken() {
  // get token from url params first. miniapp uses this to pass token to webview
  if (Platform.OS === 'web' && typeof window !== 'undefined' && window.location?.href) {
    const url = new URL(window.location.href)
    const urlToken = url.searchParams.get('mt') || url.searchParams.get('token')
    if (urlToken) {
      url.searchParams.delete('mt')
      url.searchParams.delete('token')
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash)
      setAuthToken(urlToken)
      return urlToken
    }
  }

  // then from local storage
  return storage.get<string>(AUTH_TOKEN_KEY)
}

export function removeAuthToken() {
  storage.remove(AUTH_TOKEN_KEY)
}

export function redirectAutoLogout() {
  if (Platform.OS !== 'web') return

  const apiBaseUrl = process.env.EXPO_PUBLIC_API_BASE_URL
  window.location.href = `${apiBaseUrl}/auto_logout`
}

export function setAuthToken(token: string | null) {
  if (!token) {
    storage.remove(AUTH_TOKEN_KEY)
    return
  }
  storage.set(AUTH_TOKEN_KEY, token)
}

/**
 * Check for auth token in _gd_m_t cookie (set by Rails during redirect).
 * Called once during app initialization on web.
 */
export function consumeTokenFromCookie() {
  if (Platform.OS !== 'web' || typeof document === 'undefined') {
    return
  }
  const token = Cookies.get(COOKIE_NAME)
  if (!token) return

  setAuthToken(token)
  Cookies.remove(COOKIE_NAME, { path: '/' })
  // Also remove on parent domain to cover .jinshuju.net
  const domain = window.location.hostname.replace(/^[^.]+/, '')
  if (domain) {
    Cookies.remove(COOKIE_NAME, { path: '/', domain })
  }
}
